import React, { useState, useEffect, useContext } from 'react';
import { AppContext } from '../../Context';
import { doc, getDocs, getFirestore, collection, addDoc, updateDoc, deleteDoc, query, where } from 'firebase/firestore';
import { Button, Table, Form } from 'react-bootstrap';
import Swal from 'sweetalert2';

const SesionAlumno = () => {
  const { currentUser } = useContext(AppContext); // Obtén el usuario actual desde el contexto
  const db = getFirestore(); // Inicializa Firestore
  const [fichas, setFichas] = useState([]); // Estado para almacenar las sesiones

  useEffect(() => {
    if (!currentUser?.uid) {
      console.error("El ID del alumno no está definido.");
      return;
    }

    const fetchFichas = async () => {
      try {
        // Consulta los registros de "sesiones" que tengan "alumnoId" igual al ID del alumno logueado
        const sesionesRef = collection(db, 'sesiones');
        const q = query(sesionesRef, where('alumnoId', '==', currentUser.uid));
        const querySnapshot = await getDocs(q);

        if (querySnapshot.empty) {
          // Si no hay contenido en la colección "sesiones", crea un nuevo documento
          const newFicha = {
            alumnoId: currentUser.uid,
            modulo: '',
            ejercicios: '',
            velocidad: '',
            comprension: '',
            lecturaRealizada: '',
            observaciones: ''
          };
          const docRef = await addDoc(collection(db, 'sesiones'), newFicha);
          setFichas([{ id: docRef.id, ...newFicha }]);
        } else {
          // Si hay contenido, establece las sesiones existentes en el estado
          const sesiones = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          setFichas(sesiones);
        }
      } catch (error) {
        console.error('Error fetching fichas:', error);
      }
    };

    fetchFichas();
  }, [currentUser, db]);

  const handleChange = (index, field, value) => {
    const updatedFichas = fichas.map((ficha, i) =>
      i === index ? { ...ficha, [field]: value } : ficha
    );
    setFichas(updatedFichas);
  };

  const handleAddRow = () => {
    setFichas([
      ...fichas,
      {
        id: null,
        alumnoId: currentUser?.uid,
        modulo: '',
        ejercicios: '',
        velocidad: '',
        comprension: '',
        lecturaRealizada: '',
        observaciones: ''
      }
    ]);
  };

  const handleSave = async (index) => {
    const ficha = fichas[index];
    if (!ficha.alumnoId || !ficha.modulo) {
      Swal.fire({
        icon: 'error',
        title: 'Datos inválidos',
        text: 'Por favor, completa todos los campos obligatorios.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
      return;
    }

    try {
      if (ficha.id) {
        await updateDoc(doc(db, 'sesiones', ficha.id), ficha);
      } else {
        const docRef = await addDoc(collection(db, 'sesiones'), ficha);
        setFichas(prev => {
          const updated = [...prev];
          updated[index] = { ...ficha, id: docRef.id };
          return updated;
        });
      }
      Swal.fire('Guardado', 'La sesión ha sido guardada con éxito.', 'success');
    } catch (error) {
      console.error('Error al guardar:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al guardar',
        text: 'Ocurrió un error al intentar guardar la sesión.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  const handleDelete = async (index) => {
    const ficha = fichas[index];
    try {
      if (ficha.id) {
        await deleteDoc(doc(db, 'sesiones', ficha.id));
        setFichas(fichas.filter((_, i) => i !== index));
        Swal.fire({
          title: 'Eliminado',
          text: 'La sesión ha sido eliminada con éxito.',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Aceptar'
        });
      }
    } catch (error) {
      console.error('Error al eliminar:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error al eliminar',
        text: 'Ocurrió un error al intentar eliminar la sesión.',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Aceptar'
      });
    }
  };

  return (
    <div className='container'>
      <h1>Sesiones del Alumno</h1>
      <Button onClick={handleAddRow}>Añadir Sesión</Button>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>N-sesión</th>
            <th>Módulo</th>
            <th>Ejercicios</th>
            <th>Velocidad</th>
            <th>Comprensión</th>
            <th>Lectura realizada</th>
            <th>Observaciones</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {fichas.map((ficha, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.modulo}
                  onChange={(e) => handleChange(index, 'modulo', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.ejercicios}
                  onChange={(e) => handleChange(index, 'ejercicios', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.velocidad}
                  onChange={(e) => handleChange(index, 'velocidad', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.comprension}
                  onChange={(e) => handleChange(index, 'comprension', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.lecturaRealizada}
                  onChange={(e) => handleChange(index, 'lecturaRealizada', e.target.value)}
                />
              </td>
              <td>
                <Form.Control
                  type="text"
                  value={ficha.observaciones}
                  onChange={(e) => handleChange(index, 'observaciones', e.target.value)}
                />
              </td>
              <td>
                <Button onClick={() => handleSave(index)}>Guardar</Button>
                <Button variant="danger" onClick={() => handleDelete(index)}>Eliminar</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default SesionAlumno;
